module.exports = __webpack_public_path__ + "static/media/Cteam logo.4332d63a.png";